 
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

export type SupportedEnvironments = 'acceptance' |
                                    'prod' |
                                    'staging' |
                                    'localhost';

export interface IEnvironmentConfig {
  production: boolean;
  hmr: boolean;
  envName: string;
  envBaseUrl?: string;
  firebaseConfig?: Record<string, unknown>;
  orderTimeoutInMinutes?: {
    warning: number;
    error: number;
  };
  stripeKey?: string;
  storefrontFallbackToOwner: boolean;
  // Opt-in flag for the QA-per-PR localStorage API override. Must be `true`
  // only in acceptance environments — never in prod or staging. Together
  // with envName === 'acceptance' it forms the second gate in BaseService.
  qaPerPrEnabled?: boolean;
}

export class EnvironmentConfig implements IEnvironmentConfig {
  production: boolean;
  hmr: boolean;
  envName: SupportedEnvironments;
  envBaseUrl?: string;
  firebaseConfig?: Record<string, unknown>;
  orderTimeoutInMinutes?: {
    warning: number;
    error: number;
  };
  stripeKey?: string;
  storefrontFallbackToOwner: boolean;
  qaPerPrEnabled?: boolean;

  constructor(args: IEnvironmentConfig) {
    const {
      production,
      hmr,
      envName,
      envBaseUrl,
      firebaseConfig,
      orderTimeoutInMinutes,
      stripeKey,
      storefrontFallbackToOwner,
      qaPerPrEnabled,
    } = args;

    this.production = production;
    this.hmr = hmr;
    this.firebaseConfig = firebaseConfig;
    this.orderTimeoutInMinutes = orderTimeoutInMinutes;
    this.stripeKey = stripeKey;
    this.storefrontFallbackToOwner = storefrontFallbackToOwner;
    this.qaPerPrEnabled = qaPerPrEnabled;

    switch (envName) {
    case 'acceptance':
    case 'prod':
    case 'staging':
    case 'localhost': {
      this.envName = envName;
      this.envBaseUrl = envBaseUrl;
    }                 break;

    default: {
      throw new Error('Unsupported configuration!');
    }
    }
  }
}

export interface IEnvironmentService {
  resolve(): EnvironmentConfig;
}

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService implements IEnvironmentService {
  resolve(): EnvironmentConfig {
    return new EnvironmentConfig(environment);
  }
}
 
